module.exports = __webpack_public_path__ + "img/pp-26.2f046cf9.jpg";